export const showAddDocumentAction = (
  status: string,
  isABFL_BL: boolean,
  isLanUpdated: boolean
) => {
  if (!isABFL_BL) return true;
  if (status === "DISBURSED") return false;
  if (status === "SIGN_AGREEMENT") return !isLanUpdated;

  return true;
};

export const showDeleteDocumentAction = (
  status: string,
  isABFL_BL: boolean,
  isLanUpdated: boolean
) => {
  if (!isABFL_BL) return true;
  if (status === "DISBURSED") return false;
  if (status === "SIGN_AGREEMENT") return !isLanUpdated;

  return true;
};
